import { useCallback, useEffect, useState } from "react";
import { IPayerBalance } from "../interface/ICurrentBalance";
import { getAccountBalanceApiRoute } from "@api-routes/accountReceivableFacade";
import { getResponseToState, IPayerBalanceResponse } from "../mappers/getPaymentBalanceMapper";
import { useFetch } from "@common/hook/useFetch";

interface IParams {
    accountId: string;
}

export const usePaymentBalance = (props: IParams) => {
    const { accountId } = props;
    const [balanceDetails, setBalanceDetails] = useState<IPayerBalance>();
    const [getCurrentBalanceState, { get }] = useFetch();

    const getCurrentBalance = useCallback(() => {
        get<IPayerBalanceResponse[]>(getAccountBalanceApiRoute(accountId), {
            headers: {
                "Cache-Control": "no-cache",
            },
        }).then((payerBalanceResponse) => {
            if (payerBalanceResponse) {
                setBalanceDetails(getResponseToState(payerBalanceResponse));
            }
        });
    }, [get, accountId]);

    useEffect(getCurrentBalance, [getCurrentBalance]);

    return { balanceDetails, getCurrentBalanceState, getCurrentBalance };
};
